import React from "react";

interface Props {
  onSearch: any ; // Replace 'any' with the specific type if known
}

const SearchBar: React.FC<Props> = ({ onSearch }) => {
  const [query, setQuery] = React.useState("");

  const handleSearch = (e : React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };
  return (
    <div className="position-relative w-100">
      <input
        type="text"
        value={query}
        onChange={handleSearch}
        placeholder="Search..."
        className="form-control rounded-2 ps-4 pe-5"
        aria-label="Search"
        style={{ height: "46px" }}
      />

      <svg
        className="position-absolute end-0 top-50 translate-middle-y me-3"
        style={{ width: "20px", height: "20px", color: "#6c757d" }}
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5.63201C1 6.2771 1.13077 6.91587 1.38483 7.51186C1.6389 8.10784 2.01129 8.64937 2.48074 9.10551C2.95019 9.56166 3.50751 9.9235 4.12088 10.1704C4.73424 10.4172 5.39165 10.5443 6.05555 10.5443C6.71946 10.5443 7.37686 10.4172 7.99023 10.1704C8.6036 9.9235 9.16091 9.56166 9.63037 9.10551C10.0998 8.64937 10.4722 8.10784 10.7263 7.51186C10.9803 6.91587 11.1111 6.2771 11.1111 5.63201C11.1111 4.98692 10.9803 4.34814 10.7263 3.75216C10.4722 3.15617 10.0998 2.61465 9.63037 2.1585C9.16091 1.70235 8.6036 1.34052 7.99023 1.09365C7.37686 0.846786 6.71946 0.719727 6.05555 0.719727C5.39165 0.719727 4.73424 0.846786 4.12088 1.09365C3.50751 1.34052 2.95019 1.70235 2.48074 2.1585C2.01129 2.61465 1.6389 3.15617 1.38483 3.75216C1.13077 4.34814 1 4.98692 1 5.63201Z"
          stroke="#6E42E5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9998 13.3512L9.6665 9.14062"
          stroke="#6E42E5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default SearchBar;
